import {Component, EventEmitter, Input, Output, AfterViewInit, AfterViewChecked, ElementRef, ViewChild, ChangeDetectorRef} from '@angular/core';
import { NgIf } from '@angular/common';
import { Airport } from '../../../../model/airport';
import { AirportService } from '../../../../services/airport.service';
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-airports-slider-el',
  imports: [
    NgIf
  ],
  templateUrl: './airports-slider-el.component.html',
  styleUrl: './airports-slider-el.component.scss'
})
export class AirportsSliderElComponent implements AfterViewInit, AfterViewChecked {
  constructor(
    public airportService: AirportService,
    private cdr: ChangeDetectorRef,
    public languageService: LanguageService
  ) {}

  @Input() el: Airport = new Airport();
  @Input() isActive = false;
  @Input() canDelete = false;
  @Input() hasError = false;

  @Output() deleteAirport = new EventEmitter<MouseEvent>();

  @ViewChild('titleRef') titleRef!: ElementRef<HTMLDivElement>;

  isTitleOverflow = false;

  ngAfterViewInit() {
    setTimeout(() => {
      this.checkTitleOverflow();
    });
  }

  ngAfterViewChecked() {
    this.checkTitleOverflow();
  }

  private checkTitleOverflow() {
    const titleEl = this.titleRef?.nativeElement;
    if (!titleEl) return;

    const isOverflow = titleEl.scrollWidth > titleEl.clientWidth;

    if (this.isTitleOverflow !== isOverflow) {
      this.isTitleOverflow = isOverflow;
      this.cdr.detectChanges();
    }
  }

  getAirportName(): string {
    if (this.languageService.currentLanguage === 'ru') {
      return this.el.names?.['ru']
        ?? this.el.name
        ?? '';
    }

    return this.el.name ?? '';
  }

  getAirportCountry(): string {
    if (this.languageService.currentLanguage === 'ru') {
      return this.el.countryObject?.names?.['ru']
        ?? this.el.countryObject?.name
        ?? this.el.country_code
        ?? '';
    }

    return this.el.countryObject?.name ?? this.el.country_code ?? '';
  }

  getAirportSubtitle(): string {
    return `${this.el.city_code || this.el.iata_code || this.el.icao_code || ''} • ${this.getAirportCountry()}`;
  }

  getAirportFlagAlt(): string {
    return this.getAirportCountry();
  }

  getRouteRoleTitle(): string {
    switch (this.el.routeRole) {
      case 'departure':
        return this.languageService.translate(['Departure', 'Вылет']);
      case 'transit':
        return this.languageService.translate(['Transit', 'Транзит']);
      case 'arrival':
        return this.languageService.translate(['Arrival', 'Прилет']);
      default:
        return '';
    }
  }
}
